import React from 'react';
import PropTypes from 'prop-types';

import './LikesIcon.scss';

const LikesIcon = ({ isActive }) => {
    const activeStyle = isActive ? 'active' : '';
    return (
        <svg
            className={`component-LikesIcon ${activeStyle}`}
            fill="none"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                className="likes-icon-outline"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.6668 2.75C13.2582 2.75 11.9732 3.27956 11.0002 4.15047C10.0271 3.27956 8.74215 2.75 7.3335 2.75C4.29593 2.75 1.8335 5.21243 1.8335 8.25C1.8335 12.6834 6.39719 16.9685 10.6136 19.4685C10.8271 19.6009 11.1765 19.5991 11.3894 19.4667C15.578 16.9583 20.1668 12.6832 20.1668 8.25C20.1668 5.21243 17.7044 2.75 14.6668 2.75ZM11.0053 17.5389C6.47236 14.5756 3.66675 11.1139 3.66675 8.25008C3.66675 6.22504 5.30837 4.58341 7.33342 4.58341C8.24966 4.58341 9.10895 4.91835 9.77741 5.51663L10.6595 6.30613C10.8502 6.47677 11.1526 6.47448 11.3407 6.30613L12.2228 5.51663C12.8912 4.91835 13.7505 4.58341 14.6667 4.58341C16.6918 4.58341 18.3334 6.22504 18.3334 8.25008C18.3334 11.1876 15.5382 14.5756 11.0053 17.5389Z"
            />
            <path
                className="like-icon-fill"
                d="M3.5 4.5H18L19 12L11 18L3 12L3.5 4.5Z"
            />
        </svg>
    );
};
LikesIcon.propTypes = {
    isActive: PropTypes.bool,
};

LikesIcon.defaultProps = {
    isActive: false,
};

LikesIcon.displayName = 'LikesIcon';

export default LikesIcon;
